import { useState } from 'react';
import Header from './components/Header';
import HeroSection from './components/HeroSection';
import OfferSection from './components/OfferSection';
import ValueStackSection from './components/ValueStackSection';
import WhyThisWorksSection from './components/WhyThisWorksSection';
import HowItWorksSection from './components/HowItWorksSection';
import SearchChannelsSection from './components/SearchChannelsSection';
import WebsiteValueSection from './components/WebsiteValueSection';
import BeforeAfterSection from './components/BeforeAfterSection';
import RiskReversalSection from './components/RiskReversalSection';
import TrustSection from './components/TrustSection';
import TestimonialsSection from './components/TestimonialsSection';
import FinalCTASection from './components/FinalCTASection';
import Footer from './components/Footer';
import PreviewFormModal from './components/PreviewFormModal';

export default function HomePage() {
  const [formOpen, setFormOpen] = useState(false);

  const openForm = () => setFormOpen(true);
  const closeForm = () => setFormOpen(false);

  return (
    <div className="min-h-screen bg-white">
      <Header onOpenForm={openForm} />
      <main>
        {/* 1. Hook — value prop + offer */}
        <HeroSection onOpenForm={openForm} />

        {/* 2. What you get */}
        <OfferSection onOpenForm={openForm} />

        {/* 3. Value stack — make price feel small */}
        <ValueStackSection onOpenForm={openForm} />

        {/* 4. Mechanism — why this works when SEO doesn't */}
        <WhyThisWorksSection onOpenForm={openForm} />

        {/* 5. How it works — simple process */}
        <HowItWorksSection onOpenForm={openForm} />

        {/* 6. Search channels — 4-platform depth */}
        <SearchChannelsSection onOpenForm={openForm} />

        {/* 7. Website value — conversion-first design */}
        <WebsiteValueSection onOpenForm={openForm} />

        {/* 8. Before vs After — contrast old vs new */}
        <BeforeAfterSection onOpenForm={openForm} />

        {/* 9. Risk reversal — remove hesitation */}
        <RiskReversalSection onOpenForm={openForm} />

        {/* 10. Trust — logos + stats + credibility */}
        <TrustSection />

        {/* 11. Proof — testimonials */}
        <TestimonialsSection />

        {/* 12. Strong close */}
        <FinalCTASection onOpenForm={openForm} />
      </main>
      <Footer />
      <PreviewFormModal isOpen={formOpen} onClose={closeForm} />
    </div>
  );
}
